import { isContainerBlock, type TBlock } from '@wp-block-builder/package';

export type TFlatBlock = {
  id: string;
  parentIds: string[];
  block: TBlock;
  depth: number;
  allowChildren: boolean;
  name: string;
};

export default function blocksToFlatDocument(blocks: TBlock[]): TFlatBlock[] {
  const results: TFlatBlock[] = [];
  const parentIds: string[] = [];
  blocks.forEach((block, i) => {
    if (block !== null) {
      const props = {
        block,
        parentIds,
        name: `configuration.blocks[${i}]`,
      };
      results.push(getFlatConfigurationBlock(props), ...getInternalBlocks(props));
    }
  });
  return results;
}

type TProps = {
  block: TBlock;
  parentIds: string[];
  name: string;
};

function getFlatConfigurationBlock({ block, parentIds, ...props }: TProps): TFlatBlock {
  return {
    ...props,
    block,
    parentIds,
    depth: parentIds.length,
    allowChildren: isContainerBlock(block),
    id: block.id,
  };
}

function getInternalBlocks({ parentIds, block, name }: TProps): TFlatBlock[] {
  if (!isContainerBlock(block)) {
    return [];
  }
  const results: TFlatBlock[] = [];
  const blocks = block.props?.blocks ?? [];
  const nParentIds = [...parentIds, block.id];

  blocks.forEach((block, i) => {
    if (block !== null) {
      const props = {
        block,
        parentIds: nParentIds,
        name: `${name}.props.blocks[${i}]`,
      };
      results.push(getFlatConfigurationBlock(props), ...getInternalBlocks(props));
    }
  });

  return results;
}
